import type ItineraryPackage from './ItineraryPackage';

export default class ItineraryOrder {
    time: number;
    price: number;
    duration: number;
    mrbilitOffer = 0;
    customOrder: (a: ItineraryPackage) => number;

    constructor(
        time: number,
        price: number,
        customOrder: (a: ItineraryPackage) => number = () => 0,
        duration = 0
    ) {
        this.time = time;
        this.price = price;
        this.duration = duration;
        this.customOrder = customOrder;
    }
}
